import { apiFetch, withAuth } from "../common/api";

const HOST = import.meta.env.VITE_API_HOST;

/**
 * @param {object} accessToken
 * @returns {Promise<Array<FlexibleDiscount>>}
 */
export async function fetchFlexibleDiscounts(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/flexible_discount`,
    withAuth(accessToken),
  );
  /**
   * @type FlexibleDiscount[]
   */
  const data = await resp.json();
  return data.filter((d) => d.available);
}

/**
 * @param {object} accessToken
 * @returns {Promise<Array<FlexibleDiscount>>}
 */
export async function fetchAll(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/flexible_discount`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  const data = await resp.json();
  return data;
}

/**
 * @param {object} accessToken
 * @param {SaveOrUpdateFlexibleDiscountRequest} req
 * @returns {Promise<void>}
 */
export async function saveOrUpdate(accessToken, req) {
  req.amount = parseInt(req.amount.replace("%", "")) / 100;
  const opts = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  const resp = await apiFetch(
    `${HOST}/api/v1/flexible_discount`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
}

/**
 * @param {object} accessToken
 * @param {number} discountId
 */
export async function archive(accessToken, discountId) {
  const opts = { method: "DELETE" };
  const resp = await apiFetch(
    `${HOST}/api/v1/flexible_discount/${discountId}`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status !== 200) {
    throw await resp.text();
  }
}
